.swp-chatbot-banner {
  display: flex;
  justify-content: center;

  &.primary {
    background: var(--stamp-color-background-brand, #F56900);
  }
  
  &.secondary {
    background: var(--stamp-color-background-variant, #F1F1F2);

    .swp-chatbot-banner-card h3 {
      color: var(--stamp-color-background-brand, #F56900);
    }
  }

  
  &.tertiary {    
    background: var(--stamp-color-background-surface, #FFF);
  }
}

@media (width <= 880px) {
  .swp-chatbot-banner {
    flex-direction: column;
    padding: 0 var(--stamp-spacing-inner-s, 8px);
  }
}